import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { WorkBody, WorkDetails, WorkListItem } from "types/api/work";

function useWorkApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllWork = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<WorkListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<WorkListItem>>({
            url: "/work",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneWork = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<WorkDetails> => {
        return get<PathParamsWithId, undefined, WorkDetails>({
            url: "/work/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createWork = React.useCallback((body: WorkBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, WorkBody, ResponseWithId>({
            url: "/work",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateWork = React.useCallback((pathParams: PathParamsWithId, body: WorkBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, WorkBody, null>({
            url: "/work/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteWork = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/work/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllWork,
        getOneWork,
        createWork,
        updateWork,
        deleteWork
    };
}

export default useWorkApi;